<script setup>
import AnalyticsIntervalSelector from "./AnalyticsIntervalSelector.vue";

defineProps({
  modelValue: { type: String, default: "this_month" },
});

const emit = defineEmits(["update:modelValue"]);
</script>

<template>
  <div class="row justify-content-center mb-0">
    <div class="col-12 col-sm-8 col-md-3 col-lg-2 analytics-period-card-col">
      <div class="card card-detail-layout">
        <div class="card-body">
          <analytics-interval-selector
            :model-value="modelValue"
            @update:model-value="emit('update:modelValue', $event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.analytics-period-card-col {
  max-width: 10rem;
}
</style>
